var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.971,
    height: 17.971,
    viewBox: "0 0 17.971 17.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18175",
    "data-name": "Path 18175",
    d: "M15.728,9.686,14.314,8.272,5,17.586V19H6.414l9.314-9.314Zm1.414-1.414,1.414-1.414L17.142,5.444,15.728,6.858ZM7.242,21H3V16.757L16.435,3.322a1,1,0,0,1,1.414,0l2.829,2.829a1,1,0,0,1,0,1.414L7.243,21Z",
    transform: "translate(-3 -3.029)",
    fill: "#6D6E6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.51710903eff58480db3acc360b2bc06b.svg";
export { ForwardRef as ReactComponent };